import { ogImage, OG_SIZE } from "@/lib/og";

export const alt = "Quto AI Blog — Voice AI guides & engineering";
export const size = OG_SIZE;
export const contentType = "image/png";

export default function Image() {
  return ogImage({
    title: "Quto AI Blog",
    eyebrow: "Voice AI guides & engineering",
  });
}
